import React from 'react';

import { flagStyles } from '../settings';

const SvgRO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4488px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgRO;
